import React from "react";
import { styled } from "@mui/material/styles";
import LeavingFDICDialog from "./LeavingFDICDialog";
import { Typography } from "@mui/material";
import { MapContainer, TileLayer, Marker } from "react-leaflet";
import clsx from "clsx";

const PREFIX = "LocationMap";

const classes = {
  map: `${PREFIX}-map`,
  attribution: `${PREFIX}-attribution`,
};

const StyledMapContainer = styled(MapContainer)({
  [`&.${classes.map}`]: {
    "& img.leaflet-marker-icon": {
      cursor: "grab",
    },
  },
  [`& .${classes.attribution}`]: {
    "&.leaflet-control-attribution ": {
      "position": "absolute",
      "bottom": 0,
      "right": 0,
      "display": "inline-flex",
      "padding": "0px 5px",

      "& *": {
        textTransform: "none",
        fontSize: 11,
      },
      "& a": {
        padding: "0px 3px",
      },
    },
  },
});

interface Props {
  lat: number;
  lng: number;
  zoom: number;
  height?: number | string;
  width?: number | string;
}

export default function LocationMap({ lat, lng, zoom, height, width }: Props) {
  const position = { lat, lng };
  return (
    <StyledMapContainer
      style={{ height, width }}
      center={position}
      zoom={zoom}
      className={classes.map}
      attributionControl={false}
    >
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <Marker position={position} />
      <Typography
        component="div"
        className={clsx(
          "leaflet-control-attribution leaflet-control",
          classes.attribution,
        )}
      >
        <LeavingFDICDialog
          webAddress="https://leafletjs.com/"
          label="Leaflet"
          noHover
        />
        <Typography component="div" style={{ fontSize: 13 }}>
          | ©
        </Typography>
        <LeavingFDICDialog
          webAddress="https://www.openstreetmap.org/copyright"
          label="OpenStreetMap"
          noHover
        />
        <Typography component="div">contributors</Typography>
      </Typography>
    </StyledMapContainer>
  );
}
